import type { ReactElement } from 'react';
import React from 'react';
import TableActions from 'atom-components/table-actions-lite';
import { markResponseHref } from 'pages/marking/helpers/presentation.helpers';

type Props = {
  responseId: number;
  markId?: number;
};

export default function MarkResponseButton({ responseId, markId }: Props): ReactElement {
  return (
    <TableActions.Link
      tooltip={`Mark Response (${markId ? 'Edit' : 'New'} Mark)`}
      href={markResponseHref(responseId, markId)}
      icon={['fas', 'pen-to-square']}
    />
  );
}
